import { useMutation } from "@tanstack/react-query";
import { fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

export const useBulkPdfGenerateMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      orderIds: string[];
      noOfPieces?: number;
      system?: "default" | "3pl";
    }) => {
      const res = await fetch5(`${url}/api/bulk/bulk-pdf`, "POST", payload);
      if (!res.success) {
        throw res.message || "Something went wrong";
      }
      return res;
    },
    onSuccess: (res: any) => {
      // Optionally handle success
      return res;
    },
    onError: (error: any) => {
      // Optionally handle error
      console.error("Bulk PDF generate request failed:", error.message);
    },
  });
};
